import React from "react";
import { useTheme } from "@mui/material/styles";

const ArrowDownIcon = ({ flip = false }) => {
  const theme = useTheme();

  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ transform: flip ? "rotate(180deg)" : "none" }}>
      <path d="M10 5V15M10 15L15 10M10 15L5 10" stroke={theme.palette.system[700]} strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};

export default ArrowDownIcon;
